import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#collapse" }),
  /*#__PURE__*/_createTextVNode(" Collapse ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Vertical NavMenu could be collapsed. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("expand")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("collapse")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-location" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Navigator One", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Group One", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("item one")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("item two")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("item three")
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "item four", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("item one")
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "el-icon-menu" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Navigator Two")
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Navigator Three")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "el-icon-setting" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Navigator Four")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_radio_group, {
        modelValue: _ctx.isCollapse,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollapse = $event)),
        style: {"margin-bottom":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { label: false }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: true }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_menu, {
        "default-active": "2",
        class: "el-menu-vertical-demo",
        onOpen: _ctx.handleOpen,
        onClose: _ctx.handleClose,
        collapse: _ctx.isCollapse
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_submenu, { index: "1" }, {
            title: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item_group, null, {
                title: _withCtx(() => [
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1-1" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "1-2" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item_group, { title: "Group Two" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1-3" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_submenu, { index: "1-4" }, {
                title: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1-4-1" }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "2" }, {
            title: _withCtx(() => [
              _hoisted_16
            ]),
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, {
            index: "3",
            disabled: ""
          }, {
            title: _withCtx(() => [
              _hoisted_18
            ]),
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "4" }, {
            title: _withCtx(() => [
              _hoisted_20
            ]),
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onOpen", "onClose", "collapse"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code3), 1)
        ]),
        _: 1
      })
    ])
  ]))
}